import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import ArticlePreview from '../components/article-preview'
import SiteMetadata from '../components/site-metadata'
import get from 'lodash/get'
import { Grid, GridColumn, Header } from 'semantic-ui-react'
import ArticleList from '../components/article-list'


class TagTemaplate extends React.Component {

  render() {
    const pageContext = get(this, 'props.pageContext.tag')
    const posts = get(this, 'props.data.allContentfulBlogPost.edges')
    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          <SiteMetadata pathname={this.props.location.pathname}
                        isIndexPage/>
          <div className="wrapper">
            <Header as={'h2'} dividing>{`Articles in '${pageContext}' tag`}</Header>
            <ArticleList posts={posts} />
          </div>
        </div>
      </Layout>
    )
  }
}

export default TagTemaplate

export const pageQuery = graphql`
    query BlogPostsByTag($tag: String!) {
        allContentfulBlogPost(filter:{tags :{in: [$tag]}}) {
            edges{
                node {
                    title
                    slug
                    publishDate
                    tags
                    heroImage {
                        fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
                            ...GatsbyContentfulFluid_tracedSVG
                        }
                    }
                    description {
                        childMarkdownRemark {
                            html
                        }
                    }
                }
            }
        }
    }
`